import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@/styles.css';
import { applyTheme, watchSystem } from '@/shared/theme';
import { installChromeShim } from './chrome-shim';
import { Webapp } from './Webapp';

installChromeShim();
// index.html's inline script already applied the theme pre-paint; re-apply for
// SPA navigations and set up the system-appearance watcher.
applyTheme();
watchSystem();

// Real URLs + history: the Go SPA handler serves index.html for any
// non-/api path (server/internal/spa/spa.go), so deep links and hard
// refreshes resolve client-side here. Auth state still gates what Webapp
// renders; the route table lives inside it.
const root = document.getElementById('root');
if (!root) throw new Error('root element missing');
createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <Webapp />
    </BrowserRouter>
  </React.StrictMode>
);
